export const RoleParams = {
    Entity: 'Entity',
    ParentEntity: 'ParentEntity',
    ChildEntity: 'ChildEntity',
    Me: 'Me',
};